import { Link } from "react-router-dom";
import { FaRegistered, FaAddressBook } from 'react-icons/fa6'
import { Card } from "react-bootstrap";
import { Col, Row } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";


export default function MenuCRM() {
    return <>
        <Breadcrumb>
            <Breadcrumb.Item><Link to="/">Inicio</Link></Breadcrumb.Item>
            <Breadcrumb.Item active>CRM</Breadcrumb.Item>
        </Breadcrumb>
        <nav>
            <Row>
                <Col sm="6" className="mb-2">
                    <Link to="/crm/clientes">
                        <Card bg="secondary">
                            <Card.Body>
                                <Card.Title>
                                    <FaAddressBook></FaAddressBook>
                                </Card.Title>
                                <Card.Text>Clientes</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col sm="6" className="mb-2">
                    <Link to="/crm/marcas">
                        <Card bg="secondary">
                            <Card.Body>
                                <Card.Title>
                                    <FaRegistered></FaRegistered>
                                </Card.Title>
                                <Card.Text>Marcas</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
        </nav>
    </>
}